module.exports = __webpack_public_path__ + "static/media/6、张掖交投发展战略、功能定位和商业模式研究咨询-min.1b8594d5.jpg";